const FALLBACK_LOCALE = "int-en";

export default {
  available: [
    "ae-ar",
    "ae-en",
    "al-sq",
    "ao-pt",
    "ar-es",
    "at-de",
    "au-en",
    "az-az",
    "ba-bs",
    "be-fr",
    "be-nl",
    "bg-bg",
    "br-pt",
    "ca-en",
    "ca-fr",
    "car-es",
    "ch-de",
    "ch-fr",
    "ci-fr",
    "cl-es",
    "cn-zh",
    "co-es",
    "cy-el",
    "cz-cs",
    "de-de",
    "dk-da",
    "ee-et",
    "eg-ar",
    "eg-en",
    "es-es",
    "fi-fi",
    "fr-fr",
    "gb-en",
    "gh-en",
    "gr-el",
    "hk-zh",
    "hr-hr",
    "hu-hu",
    "id-id",
    "ie-en",
    "in-en",
    "in-hi",
    "int-en",
    "is-is",
    "it-it",
    "jp-ja",
    "ke-en",
    "kr-ko",
    "kw-ar",
    "kw-en",
    "kz-kk",
    "kz-ru",
    "lt-lt",
    "lv-lv",
    "mea-ar",
    "mea-en",
    "mk-mk",
    "mu-fr",
    "mx-es",
    "my-en",
    "na-en",
    "ng-en",
    "nl-nl",
    "no-no",
    "nz-en",
    "pe-es",
    "ph-en",
    "pk-en",
    "pl-pl",
    "pt-pt",
    "qa-ar",
    "qa-en",
    "ro-ro",
    "rs-sr",
    "ru-ru",
    // "se-en",
    "se-sv",
    "sg-en",
    "si-sl",
    "sk-sk",
    "sn-fr",
    "tr-tr",
    "tw-zh",
    "tz-en",
    "ua-uk",
    "ug-en",
    "us-en",
    "xk-sq",
    "za-en",
  ],
  fallback: FALLBACK_LOCALE,
};
